// Types
import type { ModalType } from "../../types"

export const modal_list: ModalType[] = ["Employee", "Customer", "Vendor"]